import type { Role, User } from "@template/types";
import { apiClient } from "./client/api-client";

export interface CreateUserRequest {
  email: string;
  role: Role;
  displayName?: string;
  /** Optional — SSO-only accounts have no password. */
  password?: string;
}

export interface UpdateUserRequest {
  role?: Role;
  isActive?: boolean;
  displayName?: string;
}

export const usersApi = {
  list: () => apiClient.get<User[]>("/users"),

  create: (payload: CreateUserRequest) => apiClient.post<User>("/users", payload),

  update: (id: string, payload: UpdateUserRequest) =>
    apiClient.patch<User>(`/users/${id}`, payload),

  remove: (id: string) => apiClient.delete<void>(`/users/${id}`),
};
